import { Box, Text } from '@chakra-ui/react'

export function NotAuthorized() {
  return (
    <Box>
      <Text>Oops, you are not authorized to access this section</Text>
    </Box>
  )
}
